import 'core-js';
import './utils/dayjs';
// import './findDOMNodeShim';

import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from "react-redux";

import App from './App';
import * as serviceWorker from './serviceWorker';

import store from "./store";

import {i18n} from './config';
import {I18nextProvider} from 'react-i18next';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <I18nextProvider i18n={i18n}>
            <App/>
        </I18nextProvider>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
